var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  className: "x-circle_svg__tabler-icon x-circle_svg__tabler-icon-x x-circle_svg__invisible x-circle_svg__cursor-pointer x-circle_svg__p-0 x-circle_svg__pr-1 x-circle_svg__text-gray-450 x-circle_svg__group-hover:visible",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 6 6 18M6 6l12 12"
})));
export default SvgXCircle;